const MANSION_GLOBAL = {
  title: 'Mansion Global',
  value: 'mansionglobal',
  gams: false,
  defaultGroups: ['Dynamic Insets/IFrames'],
  sizes: [
    {
      id: 'mansionglobal-818',
      gams: 'MG818',
      label: 'Mansion Global 818x600',
      width: 818,
      height: 600,
      interactive: false,
      scale: 2,
      target: 'mansionglobal',
      publish: 'image',
      group: 'Images',
    },
    {
      id: 'mansionglobal-720',
      gams: 'MG720',
      label: 'Mansion Global 720x480',
      width: 720,
      height: 480,
      interactive: false,
      scale: 2,
      target: 'mansionglobal',
      publish: 'image',
      group: 'Images',
    },
    {
      id: 'mansionglobal-308',
      OR: true,
      gams: 'MG308',
      label: 'Mansion Global 308x250',
      width: 308,
      height: 250,
      interactive: false,
      scale: 2,
      target: 'mansionglobal',
      publish: 'image',
      group: 'Images',
    },
    {
      id: 'mansionglobal-480',
      gams: 'MG480',
      label: 'Mansion Global 480x320',
      width: 480,
      height: 320,
      interactive: false,
      scale: 2,
      target: 'mansionglobal',
      publish: 'image',
      group: 'Images',
    },
    {
      id: 'mansionglobal-4u-inset',
      label: '4U Mansion Global IFrame',
      width: 300,
      height: 400,
      minWidth: 0,
      minHeight: 200,
      maxHeight: 3000,
      interactive: true,
      scale: 2,
      target: 'mansionglobal',
      publish: 'inset',
      group: 'Dynamic Insets/IFrames',
    },
    {
      id: 'mansionglobal-8u-inset',
      label: '8U Mansion Global IFrame', // header/inline/offset',
      width: 620,
      height: 500,
      minWidth: 360,
      minHeight: 200,
      maxHeight: 3000,
      interactive: true,
      scale: 1,
      target: 'mansionglobal',
      publish: 'inset',
      group: 'Dynamic Insets/IFrames',
    },
    {
      id: 'mansionglobal-12u-inset',
      label: '12U Mansion Global IFrame', // bleed',
      width: 940,
      height: 505,
      minWidth: 621,
      minHeight: 200,
      maxHeight: 3000,
      interactive: true,
      scale: 1,
      target: 'mansionglobal',
      publish: 'inset',
      group: 'Dynamic Insets/IFrames',
    },
    // {
    //   id: 'mansionglobal-16u-inset',
    //   label: '16U Mansion Global IFrame',// bleed',
    //   width: 1260,
    //   height: 945,
    //   minWidth: 941,
    //   minHeight: 200,
    //   maxHeight: 3000,
    //   interactive: true,
    //   scale: 1,
    //   target: 'mansionglobal',
    //   publish: 'inset',
    //   group: 'Dynamic Insets/IFrames',
    // },
  ],
};

export const FALLBACK_SIZE = 'mansionglobal-4u-inset';

export const STYLES = '';

export default MANSION_GLOBAL;
